export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDfkZOLQa4cp7TjGcsGbRD0ArHMXSrCYBo',
    authDomain: 'ordenes-de-servicio-cn0xp.firebaseapp.com',
    projectId: 'ordenes-de-servicio-cn0xp',
    storageBucket: 'ordenes-de-servicio-cn0xp.firebasestorage.app',
    messagingSenderId: '360442843364',
    appId: '1:360442843364:web:c581e97066ac56902b9cf1',
  },
};
